import { Modal, Form, Button, Alert } from 'antd';
import { useStoreActions, useStoreState } from '../../store';
import { TntPaginatedTable } from './TntPaginatedTable';
import type { PaginatedTntTableData } from '../../store/timeInTransit/types';

export const TNT_PAGINATION_MODAL_KEY = 'tntPaginagionModal';
export const TntPaginationModal = () => {
  const open = useStoreState((state) => state.navigation.modals[TNT_PAGINATION_MODAL_KEY]?.open);
  const modalParams = useStoreState((state) => state.navigation.modals[TNT_PAGINATION_MODAL_KEY]?.params);
  const closeModal = useStoreActions((actions) => actions.navigation.toggleModal);
  const loading = useStoreState((state) => state.loading.loadingFlags.timeInTransit);
  const [form] = Form.useForm();

  let tntPaginatedTableData: PaginatedTntTableData[] = [];
  let errorMessage: string | null = null;

  if (modalParams instanceof Error) {
    errorMessage = `Failed to load data: ${modalParams.message}`;
  } else if (Array.isArray(modalParams)) {
    tntPaginatedTableData = modalParams;
  } else if (modalParams !== undefined) {
    errorMessage = 'Invalid data format received';
  }

  const handleCancelClick = () => {
    form.resetFields();
    closeModal({ key: TNT_PAGINATION_MODAL_KEY, open: false, params: [] });
  };

  const footer = [
    <Button key={'cancel'} onClick={handleCancelClick}>
      Cancel
    </Button>,
  ];

  return (
    <Modal title={'TNT Override Results'} width={900} open={open} onCancel={handleCancelClick} footer={footer}>
      {errorMessage ? (
        <Alert message="Error" description={errorMessage} type="error" showIcon style={{ marginBottom: 16 }} />
      ) : null}
      <TntPaginatedTable loading={loading} data={tntPaginatedTableData} />
    </Modal>
  );
};
